import { FC, useEffect, useState } from "react";
import Modal from "react-modal";
import FilterMenuView from "./FilterMenuView";
import { CurrentFilter } from "src/Models/CurrentFilter";

interface ModalProps {
  modalIsOpen: boolean;
  closeModal: () => void;
  onAddFilter: (local: LocalFilter) => void;
  days: string[];
  time_of_day: string[];
  price: string[];
  genre_feature_id:
    | {
        field: string;
        values: [
          {
            id: string;
            name: string;
            icon: string;
            icon_selected: string;
          }
        ];
      }
    | undefined;
  currentFilter: CurrentFilter;
}

export type LocalFilter = {
  days: string[];
  time_of_day: string[];
  price: string[];
  genre_feature_id: string[];
};

const FilterModal: FC<ModalProps> = ({
  modalIsOpen,
  closeModal,
  onAddFilter,
  days,
  time_of_day,
  price,
  genre_feature_id,
  currentFilter,
}) => {
  const [localFilter, setLocalFilter] = useState<LocalFilter>({
    days: [],
    time_of_day: [],
    price: [],
    genre_feature_id: [],
  });

  useEffect(() => {
    setLocalFilter({
      days: currentFilter.days as string[],
      time_of_day: currentFilter.time_of_day as string[],
      price: currentFilter.price as string[],
      genre_feature_id: currentFilter.genre_feature_id as string[],
    });
  }, [
    currentFilter.days,
    currentFilter.genre_feature_id,
    currentFilter.price,
    currentFilter.time_of_day,
  ]);

  const onAddLocalFilter = (type: string, value: string | string[]) => {
    setLocalFilter({
      ...localFilter,
      [type]: value,
    });
  };

  const root = document.getElementById("root");
  const mediaUrl = root?.getAttribute("data-static-content");

  return (
    <Modal
      className="more_filters"
      isOpen={modalIsOpen}
      contentLabel="Modal"
      ariaHideApp={false}
    >
      <img
        onClick={closeModal}
        className="close_icon"
        src={`${mediaUrl}Close.svg`}
        alt={"Close Modal"}
      />
      <div className="modal_buttons">
        <div className="wrapper">
          {genre_feature_id?.values.map((item) => (
            <div key={item.id} className={item.name === 'Most Popular' ? '' : 'feature'} >
              <FilterMenuView
                icon={item.icon}
                icon_selected={item.icon_selected}
                title={item.name}
                onClick={() => {
                  if (localFilter.genre_feature_id?.includes(String(item.id))) {
                    onAddLocalFilter("genre_feature_id", [
                      ...(currentFilter.genre_feature_id || []).filter(
                        (item) => item !== String(item)
                      ),
                    ]);
                  } else {
                    onAddLocalFilter("genre_feature_id", [String(item.id)]);
                  }
                }}
                id={String(item.id)}
                active={
                  localFilter?.genre_feature_id?.includes(String(item.id)) ||
                  false
                }
                type="genre_feature_id"
              />
            </div>
          ))}
        </div>
      </div>

      <div className="separator"></div>
      <h4 className="day_time">Day & Time</h4>
      <div className="days_options  ">
        <span>Day of the week</span>
        {days.map((day) => {
          return (
            <div key={day}>
              <input
                type="checkbox"
                checked={localFilter?.days?.includes(day)}
                onChange={(e) => {
                  if (e.target.checked) {
                    onAddLocalFilter("days", [
                      ...(localFilter?.days || []),
                      day,
                    ]);
                  } else {
                    onAddLocalFilter("days", [
                      ...(localFilter?.days || []).filter(
                        (elem) => elem !== String(day)
                      ),
                    ]);
                  }
                }}
              />{" "}
              <span>{day}</span>
            </div>
          );
        })}
      </div>
      <h4 className="time_day">Time of day</h4>
      <div className="time_options">
        {time_of_day.map((time) => {
          return (
            <div key={time}>
              <button
                className={
                  localFilter?.time_of_day?.includes(String(time))
                    ? "active"
                    : ""
                }
                onClick={() => {
                  if (localFilter?.time_of_day?.includes(String(time))) {
                    onAddLocalFilter("time_of_day", [
                      ...(localFilter?.time_of_day || []).filter(
                        (elem) => elem !== String(time)
                      ),
                    ]);
                  } else {
                    onAddLocalFilter("time_of_day", [
                      ...(localFilter?.time_of_day || []),
                      time,
                    ]);
                  }
                }}
              >
                {time}
              </button>
            </div>
          );
        })}
      </div>
      <div className="separator"></div>
      <h4 className="price_options">Price</h4>
      <div>
        {price.map((p) => {
          return (
            <div key={p}>
              <button
                className={
                  localFilter?.price?.includes(String(p)) ? "active" : ""
                }
                onClick={() => {
                  if (localFilter?.price?.includes(String(p))) {
                    onAddLocalFilter("price", [
                      ...(localFilter?.price || []).filter(
                        (elem) => elem !== String(p)
                      ),
                    ]);
                  } else {
                    onAddLocalFilter("price", [
                      ...(localFilter?.price || []),
                      String(p),
                    ]);
                  }
                }}
              >
                {Array.from(Array(p).keys()).map((n) => "$")}
              </button>
            </div>
          );
        })}
      </div>
      <div className="buttons">
        <button
          onClick={() => {
            setLocalFilter({
              days: [],
              time_of_day: [],
              price: [],
              genre_feature_id: [],
            });
            closeModal();
          }}
        >
          CANCEL
        </button>
        <button
          onClick={() => {
            onAddFilter(localFilter);
            closeModal();
          }}
        >
          APPLY FILTER
        </button>
      </div>
    </Modal>
  );
};

export default FilterModal;
